export const TRANS = {
	common: {
		male: "Mužské",
		female: "Ženské",
		send: "Odeslat",
		amount: "{count} {count, plural, =1 {kus} =2 {kusy} =3 {kusy} =4 {kusy} other {kusů}}",
		amount2: "{count} {count, plural, =1 {lžička} =2 {lžičky} =3 {lžičky} =4 {lžičky} other {lžiček}}",
		amount3: "{count} {count, plural, =1 {lžíce} =2 {lžíce} =3 {lžíce} =4 {lžíce} other {lžic}}",
		amount4: "{count} {count, plural, =1 {hrst} =2 {hrsti} =3 {hrsti} =4 {hrsti} other {hrst}}",
		amount5: "{count} {count, plural, =1 {špetka} =2 {špetky} =3 {špetky} =4 {špetky} other {špetek}}",
		amount6: "{count} {count, plural, =1 {lístek} =2 {lístky} =3 {lístky} =4 {lístky} other {lístků}}",
		amount7: "{count} {count, plural, =1 {snítka} =2 {snítky} =3 {snítky} =4 {snítky} other {snítek}}",
		save: "Uložit",
		cancel: "Zrušit",
		add: "Přidat",
		change: "Změnit",
		delete: "Vymazat",
		from: "Od:",
		to: "Do:",
		name: "Jméno",
		surname: "Příjmení",
		newsConsent: "Souhlasím se zasíláním užitečných tipů a novinek",
		email: "Email",
		ingredient: "Ingredience",
		ingredients: "Ingredience",
		quantity: "Množství",
		tableEmpty: "Tabulka je prázdná",
		missingValue: "Není zadána hodnota!",
		date: "Datum",
		value: "Hodnota",
		portions: "{count} {count, plural, one {porce} few {porce} other {porcí}}",
	},
	mainPage: {
		title: "Hlavní stránka",
		desc: "Popis hlavní stránky",
		plural: "{count, plural, =0 {Bylo tam} one {Byla tam} other {Byly tam}} {count} {count, plural, =0 {položek} one {položka} other {položky}}",
	},
	loginPage: {
		title: "Přihlášení",
		emailLogged: "Uživatel {email}",
		subtitle: "Vítejte zpět.",
		submit: "Přihlásit se",
		showPassword: "Zobrazit heslo",
		hidePassword: "Skrýt heslo",
		loginOffer: "Nemáte účet?",
		register: "Zaregistrujte se",
		email: "vas@email.cz",
		password: "heslo",
		verifyOffer: "Nepřišel vám ověřovací e-mail?",
		verifyLink: "Ověřit e-mail",
		forgotPassword: "Zapomněli jste heslo?",
		heroTitle: "Jídelníček na celý týden, připravený pro vás",
		heroPoint1: "Plán jídel podle vašich preferencí",
		heroPoint2: "Nákupní seznam sestavený za vás",
		heroPoint3: "Statistiky váhy a obvodů",
	},
	menu: {
		home: "Domů",
		schedule: "Plán jídelníčku",
		profile: "Nastavení",
		userSection: "Uživatelská sekce",
		logout: "Odhlásit se",
		languages: "Jazyk",
		czech: "Čeština",
		english: "English",
		admin: "Administrace",
		aboutus: "O nás",
		gdpr: "GDPR",
		cookies: "Cookies",
		howitworks: "Jak to funguje",
		donation: "Podpořte nás",
		conditions: "Podmínky",
		statistics: "Osobní statistiky",
		login: "Přihlášení",
		register: "Registrace",
		verify: "Ověření e-mailu",
		info: "Informace",
		web: "doitforyourself.cz",
		notLogged: "Nepřihlášený uživatel",
	},
	registerPage: {
		title: "Registrace",
		email: "Email",
		emailRequiredError: "Email je povinný!",
		emailFormatError: "Email není ve správném formátu!",
		password: "Heslo",
		createAccount: "Vytvořit účet",
		passwordRequiredError: "Heslo je povinné!",
		nameLabel: "Jméno",
		surnameLabel: "Příjmení",
		emailLabel: "E-mail",
		passwordLabel: "Heslo",
		passwordCheckLabel: "Potvrzení hesla",
		passwordCheck: "Potvrzení hesla",
		captchaError: "Potvrďte captchu!",
		healthConsentBefore: "Souhlasím se zpracováním údajů o zdraví (hmotnost, tělesné míry, cíle) za účelem sestavení jídelníčku podle",
		healthConsentLink: "zásad ochrany osobních údajů",
		healthConsentAfter: ".",
		healthConsentError: "Bez tohoto souhlasu nemůžeme sestavit jídelníček.",
		submit: "Registrovat",
		termsBefore: "Registrací souhlasíte s",
		termsLink: "podmínkami",
		termsAfter: " a provozními informacemi",
		infoTitle: "Váš jídelníček na míru ZDARMA",
		infoText: "Abychom pro vás mohli sestavit jídelníček, potřebujeme znát parametry jako je váha, výška, věk atd.",
		infoText2: "Díky registraci se navíc ke svému jídelníčku můžete kdykoliv vrátit a sledovat své pokroky. Vše je zcela ZDARMA a bez skrytých poplatků.",
		infoConfirm: "JDEME NA TO",
		subtitle: "Zdarma a bez skrytých poplatků.",
		loginOffer: "Už máte účet?",
		loginLink: "Přihlaste se",
	},
	userPage: {
		title: "Uživatelská sekce pro {email}",
		userData: "Uživatelská data",
		dataIsLoading: "Data se načítají...",
		unauthorized: "Pro pokračování se přihlaste",
	},
	adminPage: {
		unitsList: "Seznam jednotek",
		ingredients: "Ingredience",
		macrosList: "Seznam maker",
		mealsList: "Seznam jídel",
		recipes: "Recepty",
		tags: "Tagy",
		users: "Uživatelé",
		mailTemplates: "E-maily",
		menus: "Jídelníčky",
	},
	// chyby ze serveru, server posila kod (napr. "common.saveFailed") a frontend ho prelozi (transError)
	errors: {
		common: {
			unknown: "Něco se nepovedlo. Zkuste to prosím znovu.",
			saveFailed: "Změny se nepodařilo uložit. Zkuste to prosím znovu.",
			loadFailed: "Data se nepodařilo načíst. Zkuste obnovit stránku.",
			missingData: "Chybí potřebné údaje. Zkuste to prosím znovu.",
			forbidden: "Na tuto akci nemáte oprávnění.",
			network: "Nepodařilo se spojit se serverem. Zkontrolujte připojení a zkuste to znovu.",
			sessionExpired: "Přihlášení vypršelo, přihlaste se prosím znovu.",
		},
		login: {
			wrongCredentials: "Nesprávný e-mail nebo heslo.",
			notVerified: "E-mail ještě není ověřený. Klikněte na odkaz v e-mailu, který jsme vám poslali.",
			userExists: "Účet s tímto e-mailem už existuje. Zkuste se přihlásit.",
			healthConsent: "Pro registraci je nutný souhlas se zpracováním údajů o zdraví.",
			passwordTooShort: "Heslo musí mít alespoň {min} znaků.",
		},
		profile: {
			missingWeight: "Pro výpočet energie vyplňte v osobních údajích svou váhu.",
			wrongPassword: "Nesprávné heslo.",
			adminCannotDelete: "Účet administrátora nelze smazat takto – musí ho smazat jiný administrátor.",
		},
		menu: {
			generateFailed: "Jídelníček se nepodařilo sestavit, pro jídlo „{meal}“ se nenašel vhodný recept. Zkuste upravit vyloučené suroviny.",
			noOtherRecipe: "Pro toto jídlo se nepodařilo najít jiný recept.",
			pastDay: "Jídlo v minulosti nelze vyměnit.",
			mealNotFound: "Jídlo v jídelníčku nebylo nalezeno. Zkuste obnovit stránku.",
		},
		exercises: {
			generateFailed: "Tréninkový plán se nepodařilo sestavit. Zkuste to prosím znovu.",
		},
		media: {
			imageNotFound: "Obrázek nebyl nalezen.",
			uploadFailed: "Obrázek se nepodařilo nahrát. Zkuste to prosím znovu.",
		},
		verify: {
			alreadyVerified: "Uživatel už byl ověřen nebo neexistuje.",
		},
		resetPassword: {
			invalidLink: "Odkaz pro obnovu hesla je neplatný nebo už vypršel. Požádejte o nový.",
		},
		rating: {
			neutralizeFirst: "Nejdřív zrušte současné hodnocení receptu.",
		},
		users: {
			cannotDeleteSelf: "Vlastní účet nelze smazat.",
		},
		unsubscribe: {
			invalidLink: "Neplatný odkaz pro odhlášení odběru.",
		},
		mailing: {
			sendFailed: "E-mail se nepodařilo odeslat: {detail}",
			templateIncomplete: "Šablona nemá vyplněnou českou i anglickou verzi.",
			userNotFound: "Uživatel nebyl nalezen.",
		},
	},
	// hlasky (oznameni a chyby formularu) z frontendu
	notifications: {
		login: {
			success: "Uživatel byl úspěšně přihlášen!",
			afterRegistration: "Registrace proběhla úspěšně, zkontrolujte příchozí e-mail k ověření uživatele.",
			afterPasswordReset: "Heslo bylo změněno, teď se můžete přihlásit.",
			emailResent: "E-mail byl znovu poslán!",
			emptyEmail: "Vyplňte e-mail!",
			emptyPassword: "Vyplňte heslo!",
		},
		register: {
			emptyName: "Vyplňte jméno!",
			emptySurname: "Vyplňte příjmení!",
			emptyPasswordRepeat: "Zadejte znovu heslo!",
		},
		profile: {
			updated: "Profil byl aktualizován!",
			missingNewPassword: "Chybí nové heslo!",
			missingPasswordCheck: "Chybí kontrola hesla!",
			passwordsMismatch: "Hesla se neshodují!",
			missingOldPassword: "Chybí původní heslo!",
			photoChanged: "Fotka byla změněna!",
			photoRemoved: "Fotka byla odstraněna!",
			accountDeleted: "Účet byl smazán.",
			readPhotoFailed: "Fotku se nepodařilo načíst.",
			fillRequired: "Vyplňte všechny potřebné údaje!",
			// nevyplnene udaje profilu, vypisuji se v upozorneni nad strankou
			fields: {
				birthdate: "datum narození",
				weight: "váha",
				height: "výška",
				sex: "pohlaví",
			},
		},
		schedule: {
			maxDays: "Maximální počet dní je {max}!",
			generated: "Jídelníček byl vygenerován!",
			mealRegenerated: "Jídlo bylo vyměněno!",
			recipeNotFound: "Recept nenalezen!",
			shoppingEmpty: "Pro vybrané dny nemáte žádný jídelníček.",
		},
		stats: {
			valueAdded: "Hodnota byla vložena!",
		},
		preferences: {
			addIngredientFailed: "Nepodařilo se přidat ingredienci!",
			removeIngredientFailed: "Nepodařilo se odebrat ingredienci!",
			addTagFailed: "Nepodařilo se přidat tag!",
			removeTagFailed: "Nepodařilo se odebrat tag!",
		},
		admin: {
			renamed: "Přejmenováno!",
			missingTagName: "Není vyplněn název tagu!",
			missingIngredientName: "Chybí název ingredience!",
			dataUpdated: "Data byla aktualizována!",
			emailResent: "E-mail byl znovu poslán!",
		},
	},
	profilePage: {
		title: "Osobní údaje",
		userEnergy: "Energie uživatele:",
		nameSection: "Jméno",
		address: "Adresa",
		street: "Ulice a číslo popisné",
		city: "Město",
		zipcode: "PSČ",
		country: "Stát",
		menuData: "Údaje pro výpočet jídelníčku",
		sex: "Pohlaví",
		birthYear: "Rok narození",
		height: "Výška [cm]",
		weight: "Váha [kg]",
		trainingPlan: "Tréninkový plán",
		foodPlan: "Rozložení jídel",
		resultGroup: "Cílová skupina",
		maxDifficulty: "Maximální složitost generovaných receptů:",
		passwordChange: "Změna hesla",
		oldPassword: "Aktuální heslo",
		newPassword: "Nové heslo",
		passwordCheck: "Kontrola hesla",
		other: "Ostatní",
		mealsPerDay: "{count}x denně",
	},
	mobileWeek: {
		prevWeek: "Předchozí týden",
		nextWeek: "Další týden",
		goToday: "Přejít na dnešní den",
		pastDay: "Uplynulý den",
		today: "Dnes",
		cannotGenerate: "nelze sestavit",
		noMenu: "bez jídelníčku",
		pastDayInfo: "Tento den už uplynul, jídelníček pro něj nejde sestavit.",
		emptyDayInfo: "Pro tento den zatím nemáte jídelníček. Sestavíte ho tlačítkem dole.",
		generate: "Sestavit",
		shopping: "Nákup",
		daysCount: "Počet dnů:",
		maxDays: "(nejvýše {max})",
		replacedDays: "Pro {count} {count, plural, one {den} few {dny} other {dní}} z vybraných už jídelníček máte, sestavením se nahradí novým.",
		generating: "Sestavuji…",
		showList: "Zobrazit seznam",
	},
	schedule: {
		generateMenu: "Sestavit jídelníček",
		shoppingList: "Nákupní seznam",
		shoppingPdf: "Nákupní košík.pdf",
		menuCreation: "Sestavení jídelníčku",
		totalDays: "Celkový počet dnů:",
		yourDay: "Váš den {date}",
		days: "Dny {date}",
		showShoppingList: "Zobrazit nákupní seznam",
		selectionError: "Pro sestavení jídelníčku vyberte pouze dny, pro které ještě nemáte sestavený jídelníček.",
		oldDate: "Pro sestavení jídelníčku vybírejte dny, které nás teprve čekají.",
		shoppingDesc: "Pro vybrané dny si můžete zobrazit nákupní seznam potřebných surovin.",
	},
	meals: {
		leftoverFromDay: "Zbytek {day, select, 0 {z neděle} 1 {z pondělí} 2 {z úterý} 3 {ze středy} 4 {ze čtvrtka} 5 {z pátku} other {ze soboty}}",
		leftoverFromDate: "Zbytek ze dne {date}",
		cookFor: "Uvařte na {count} {count, plural, few {dny} other {dní}}",
		regenerate: "Vyměnit jídlo",
		title: "Jídelníček",
		empty: "Prázdný",
		confirmTitle: "Vyměnit jídlo na více dní?",
		confirmLabel: "Vyměnit",
		confirmText: "je uvařené na {count} {count, plural, few {dny} other {dní}}. Výměnou se změní i jeho zbytky v těchto dnech:",
		confirmNote: "Pokud už máte nakoupeno podle nákupního seznamu, suroviny se budou lišit.",
	},
	page404: {
		title: "Jejda, tohle tady nemáme!",
		text: "Stránka, kterou hledáte, neexistuje nebo byla přesunuta.",
		home: "Zpět na hlavní stránku",
	},
	accessGate: {
		forbiddenTitle: "Na tuto stránku nemáte oprávnění",
		forbiddenText: "Stránka je dostupná jen administrátorům.",
		back: "Zpět na jídelníček",
		loginText: "Jídelníček, nákupní seznam a statistiky jsou dostupné po přihlášení.",
		noAccount: "Nemáte účet?",
		register: "Zaregistrujte se",
		noEmail: "Nepřišel ověřovací e-mail?",
		verify: "Ověřit e-mail",
	},
	profileMeta: {
		photo: "Profilový obrázek",
		choosePhoto: "Vybrat obrázek",
		darkMode: "Tmavý režim",
		lightMode: "Světlý režim",
		deleteAccount: "Odstranit účet",
		deleteTitle: "Opravdu chcete smazat účet?",
		deleteText: "Smažou se i všechna vaše data – jídelníčky, statistiky, preference a hodnocení receptů. Tento krok nelze vrátit zpět.",
		deletePassword: "Pro potvrzení zadejte heslo",
		deleteConfirm: "Smazat účet",
	},
	unsubscribePage: {
		title: "Odběr novinek",
		done: "Odběr novinek byl zrušen. Další tipy a novinky Vám už nebudeme posílat.",
		resubscribe: "Pokud si to rozmyslíte, odběr můžete znovu zapnout v nastavení v osobních údajích.",
	},
	stats: {
		weight: "Hmotnost",
		waist: "Obvod pasu",
		chest: "Obvod hrudi",
		side: "Obvod boků",
		energy: "Energie",
		input: "Zadávání statistik",
		type: "Typ statistiky:",
		valueLabel: "Hodnota:",
		addValue: "Přidání nové hodnoty",
		noData: "Zatím tu nejsou žádné hodnoty. První přidáte níže.",
	},
	shopping: {
		title: "Nákupní seznam",
		ingredient: "Surovina",
	},
	preferencesPage: {
		title: "Preference",
		excludedIngredients: "Seznam vyloučených ingrediencí",
		addIngredient: "Přidat ingredienci",
		ingredientsEmpty: "Seznam ingrediencí je prázdný",
		excludedTags: "Seznam vyloučených tagů",
		tags: "Tagy",
		addTag: "Přidat tag",
		tagsEmpty: "Seznam tagů je prázdný",
	},
	donation: {
		title: "DĚKUJEME ZA VAŠI PODPORU!",
		text: "Doufáme, že se Vám aplikace líbí. Pokud máte chuť vyjádřit spokojenost a ocenit čas, který jsme vývoji věnovali, můžete nám poslat malé poděkování. Každé podpory si nesmírně vážíme.",
		card: "Platba kartou / Apple Pay",
		qr: "QR platba (39 Kč)",
		bank: "Fio banka:",
	},
	forgotPasswordPage: {
		title: "Zapomenuté heslo",
		text: "Zadejte e-mail, se kterým jste se registrovali, a pošleme vám odkaz pro nastavení nového hesla.",
		submit: "Poslat odkaz",
		sent: "Pokud účet s e-mailem {email} existuje, poslali jsme na něj odkaz pro nastavení nového hesla. Odkaz platí 1 hodinu. Zkontrolujte i složku s nevyžádanou poštou.",
		loginOffer: "Vzpomněli jste si?",
	},
	resetPasswordPage: {
		title: "Nové heslo",
		text: "Zvolte si nové heslo, alespoň {min} znaků.",
		passwordLabel: "Nové heslo",
		submit: "Uložit nové heslo",
		newLink: "Poslat nový odkaz",
	},
	favoriteRecipesPage: {
		title: "Oblíbené recepty",
		text: "Recepty, které jste v detailu receptu označili palcem. Recepty „Chutná mi“ budeme do jídelníčku vybírat častěji, recepty „Nechutná mi“ do něj nevybereme. Kliknutím na palec hodnocení zrušíte.",
		liked: "Chutná mi",
		disliked: "Nechutná mi",
		likedEmpty: "Zatím nemáte žádný oblíbený recept.",
		dislikedEmpty: "Zatím nemáte žádný neoblíbený recept.",
	},
	recipeRating: {
		like: "Chutná mi",
		dislike: "Nechutná mi",
		likes: "Počet hodnocení chutná",
		dislikes: "Počet hodnocení nechutná",
		remove: "Zrušit hodnocení",
		removeLikeFirst: "Nejdřív zrušte hodnocení „Chutná mi“",
		removeDislikeFirst: "Nejdřív zrušte hodnocení „Nechutná mi“",
	},
	verifyPage: {
		title: "Ověření e-mailu",
		text: "Zadejte e-mail, se kterým jste se registrovali, a ověřovací odkaz vám pošleme znovu.",
		submit: "Poslat ověřovací e-mail",
		loginOffer: "Už máte ověřený účet?",
		loginLink: "Přihlaste se",
		confirmTitle: "Potvrzení emailu",
	},
	nutrition: {
		proteins: "Bílkoviny",
		proteinsShort: "B",
		carbohydrates: "Sacharidy",
		carbohydratesShort: "S",
		fats: "Tuky",
		fatsShort: "T",
	},
	fillProfile: {
		before: "V ",
		link: "profilu",
		after: " chybí vyplnit:",
	},
	difficulty: {
		level1: "Velmi snadné",
		level2: "Snadné",
		level3: "Středně náročné",
		level4: "Náročné",
		level5: "Velmi náročné",
	},
	// <title> a meta popis stranky
	meta: {
		title: "Jídelníček na míru | Do It For Yourself",
		description: "Profesionální online jídelníček Do It For Yourself - zcela ZDARMA. Získejte online jídelníček sestavený přesně pro Vaše potřeby s možností konzultace s výživovým poradcem.",
	},
	day: {
		monday: "Pondělí",
		tuesday: "Úterý",
		wednesday: "Středa",
		thursday: "Čtvrtek",
		friday: "Pátek",
		saturday: "Sobota",
		sunday: "Neděle",
	},
};
